function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var TransformType = {
  'top-left': function topLeft(percent) {
    return "translate3d(".concat((percent - 1) * 100, "%,0,0)");
  },
  'top-right': function topRight(percent) {
    return "translate3d(".concat((1 - percent) * 100, "%,0,0)");
  },
  'top-center': function topCenter(percent) {
    return "translate3d(0,".concat((percent - 1) * 48, "px,0)");
  },
  'bottom-left': function bottomLeft(percent, height, space) {
    return "translate3d(".concat((percent - 1) * 100, "%,").concat((percent - 1) * (height + space), "px,0)");
  },
  'bottom-right': function bottomRight(percent, height, space) {
    return "translate3d(".concat((1 - percent) * 100, "%,").concat((percent - 1) * (height + space), "px,0)");
  },
  'bottom-center': function bottomCenter(percent) {
    return "translate3d(0,".concat((1 - percent) * 48, "px,0)");
  }
};
export function getAnimationConfig(space, placement) {
  var getStyle = function getStyle(percent, height) {
    return {
      opacity: percent,
      height: "".concat(height * percent, "px"),
      marginBottom: "".concat(space * percent, "px"),
      transform: TransformType[placement](percent, height, space)
    };
  };

  return {
    duration: 200,
    childRefKey: 'wrapperRef',
    enterChildProps: function enterChildProps(prev) {
      return {
        style: _objectSpread(_objectSpread({}, getStyle(0, 144)), prev.style)
      };
    },
    enterTick: function enterTick(domNode, percent, memo) {
      if (percent >= 1) {
        removeStyleProperties(domNode, 'height', 'opacity', 'transform');
        return memo;
      }

      var child = domNode.firstElementChild;
      var height = memo || (child === null || child === void 0 ? void 0 : child.getBoundingClientRect().height);

      if (height) {
        setStyleProperties(domNode, getStyle(percent, height));
      }

      return height;
    },
    leaveTick: function leaveTick(domNode, percent, memo) {
      if (percent >= 1) {
        return memo;
      }

      var height = memo || domNode.getBoundingClientRect().height;

      if (height) {
        setStyleProperties(domNode, getStyle(1 - percent, height));
      }

      return height;
    }
  };
}

function removeStyleProperties(element) {
  for (var _len = arguments.length, properties = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    properties[_key - 1] = arguments[_key];
  }

  properties.forEach(function (property) {
    return element.style.removeProperty(getStyleKey(property));
  });
}

function setStyleProperties(element, style) {
  var keys = Object.keys(style);
  keys.forEach(function (key) {
    return element.style.setProperty(getStyleKey(key), "".concat(style[key]));
  });
}

function getStyleKey(key) {
  return key.replace(/(?=[A-Z])/g, '-').toLowerCase();
}